import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  addButton: {
    color: theme.palette.common.blue400,
  },
}));
